/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { Avatar, Checkbox, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import ProfilePic from '../../../../../../../../../components/Common/ProfilePic';

const AddHostsBody = (props) =>
{
	const { empData, handleCheckBox, slctdUsers, alrdyAddedUsersref, feedType } = props;
	const { language } = useContext(LanguageContext);

	console.log('🚀*** empData:', empData);

	return (
		<>
			<TableRow
				key={empData?._id}
				// sx={{ opacity: alrdyAddedUsersref?.current?.some((user) => user?.userId === empData?.userId) ? '0.5' : '1.0' }}>
				sx={{
					opacity : [ 'editOccasion', 'tagPeople' ].includes(feedType)
						? '1.0'
						: (alrdyAddedUsersref?.current?.some((user) => user?.userId === empData?.userId) ? '0.5' : '1.0')
				}}
			>
				<TableCell sx={{ padding: '6px', width: '64px' }}>
					<Checkbox
						disabled={![ 'editOccasion', 'tagPeople' ].includes(feedType) && Array.isArray(alrdyAddedUsersref?.current) && alrdyAddedUsersref.current.some((user) => user?.userId === empData?.userId)}
						checked={slctdUsers?.some((emply) => emply?.userId === empData?.userId)}
						onChange={() => handleCheckBox(empData)}
					/>
				</TableCell>
				<TableCell sx={{ padding: '6px' }}>
					<Stack direction={'row'} alignItems={'center'}>
						<Avatar src={`${process.env.REACT_APP_S3_BASE_URL}/profile/${empData?.userId}_profile.jpeg`} alt='' />
						<Stack direction={'column'} p='var(--pixel8)'>
							<Typography sx={{ textTransform: 'capitalize' }}>{empData?.name}</Typography>
							<Typography>{empData?.empId}</Typography>
						</Stack>
					</Stack>
				</TableCell>
				{/* <TableCell>{empData?.email}</TableCell> */}
				{/* <TableCell>{empData?.empRole}</TableCell> */}
				<TableCell sx={{ padding: '6px' }}>{empData?.designation ?	(empData.designation) : (<span style={{ paddingLeft: '20px' }}> - </span>)}</TableCell>
			</TableRow>
		</>
	);
};

export default AddHostsBody;